// extracted by mini-css-extract-plugin
export default {"tasksContainer":"EventPageTasks_tasksContainer__ZLe6C","title":"EventPageTasks_title__xcE95"};